// extracted by mini-css-extract-plugin
export var overlapBorder = "Tk44_";
export var segButton = "kxT5Y";